export const DiccionarioLogin_EN = [
    {
        'codigo': 'ErrorActualizarClave',
        'mensaje': 'Problems occurred while performing password recovery'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'The password field is empty'
    },
    {
        'codigo': 'ErrorEmailNotFound',
        'mensaje': 'Email account not found'
    },
    {
        'codigo': 'ErrorEstLogin',
        'mensaje': 'There were problems logging in'
    },
    {
        'codigo': 'ErrorGetingDefaultCompany',
        'mensaje': 'There were problems obtaining company data'
    },
    {
        'codigo': 'ErrorGetingDefaultCompanyDB',
        'mensaje': 'There were problems obtaining company data'
    },
    {
        'codigo': 'ErrorProfLogin',
        'mensaje': 'There were problems logging in'
    },
    {
        'codigo': 'ErrorUserUnauthorized',
        'mensaje': 'The user is not authorized, check your credentials'
    },
    {
        'codigo': 'UnauthorizedPass',
        'mensaje': 'The user is not authorized, check your credentials'
    },
    {
        'codigo': 'UnauthorizedUser',
        'mensaje': 'The user is not authorized, check your credentials'
    },
    {
        'codigo': 'UserWithoutRoles',
        'mensaje': 'The user does not have permissions defined'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'Problems occurred while performing password recovery'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Password change successful'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'The user is empty'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'The password is empty'
    },
];